import gql from 'graphql-tag'
export default gql`mutation archiveRecipeMutation($recipeId: Int!) {
  archiveRecipe(recipeId: $recipeId) {
    success
  }
}`